/*///////////////////////////////
///jsonデータを振り分ける関数
///data:jsonデータ
///keyData:キー名
///////////////////////////////*/
function newsJson (data) {
  ///一旦リストを初期化
  $(".news_list").empty();
  let dataCount = 0;
  for (let i = 0; i < 3; i++ in data.contents) {
    /////////jsonデータ出力箇所をhtmlテンプレートに登録
    let contents = data.contents[i];
    let newsHtml = '<a href="/en/news/'+ contents.id +'">\
    <dt class="news_day"><span class="category cate-'+ contents.page_type +'"></span><span class="update">'+ contents.update +'</span></dt>\
    <dd>'+ contents.title +'</dd>\
    </a>'
  /////////jsonを出力したリストを表示させる
  $(newsHtml).appendTo(".news_list").hide().fadeIn();
  dataCount++;
  }
  if (dataCount <= 0) {
    $("<p>該当する情報がありません。</p>").appendTo(".news_list").hide().fadeIn();
  }
}

/*///////////////////////////////
///初期表示処理
///////////////////////////////*/
$(window).on('load',function() {
    //Ajaxに渡すデータ（初期値）
    //Ajax取得を行う
    $.ajax({
        url: NewsJson,
        dataType:"json"
    })
    .done(function(data) {
      //成功した場合の処理
      newsJson(data);
    })
    .fail(function(data) {
      //失敗した場合の処理
      $(".news_box").append("<p class=\"news_list__item\">データの取得に失敗しました。</p>");
    });
});

$(function() {
  NewsJson = '/en/' +'module' + '/' +'json' + '/' +'newsdata.json';
});
